import { render, staticRenderFns } from "./statistical.vue?vue&type=template&id=739a6582&"
import script from "./statistical.vue?vue&type=script&lang=js&"
export * from "./statistical.vue?vue&type=script&lang=js&"
import style0 from "./statistical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports